
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['close', 'confirm'],
  setup(props, context) {
    function closePopup() {
      context.emit('close');
    }

    function confirmLogout() {
      context.emit('confirm');
    }

    return {
      closePopup,
      confirmLogout,
    };
  },
});
